export const propertyOf = <T>(name: Extract<keyof T, string>): string => name;